import type { ErrorEvent, EventHint } from '@sentry/vue';

const errors = new Map([
  ['LazyLoad', ['Illegal invocation']],
  ['vendor', ['Network Error']],
]);

export default function ignoreChunkErrors(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  const [value] = event?.exception?.values || [];
  const { frames } = value?.stacktrace || {};
  const { originalException } = hint;

  if (!frames || !originalException) {
    return event;
  }

  const chunksNames = [...errors.keys()];

  const hasChunkError = (chunkName: string): boolean => {
    const hasChunk = frames.some(({ filename }) => new RegExp(chunkName).test(filename || ''));

    if (hasChunk) {
      const chunkErrors = errors.get(chunkName) || [];

      return new RegExp(chunkErrors.join('|')).test(originalException.toString());
    }

    return false;
  };

  if (chunksNames.some(hasChunkError)) {
    return null;
  }

  return event;
}
